<template>
  <span justify="center">
    <div class="text-center mb-1 font-weight-bold text-uppercase">
      <v-chip
        class="ma-2"
        color="grey darken-2"
        outlined
        label
      >
        <v-icon left>
          mdi-calendar
        </v-icon>
        FECHA DEL AUTO APELADO: {{ apelacion.fecha_apelacion | formatDate }}
      </v-chip>
      <v-chip
        class="ma-2"
        color="grey darken-2"
        outlined
        label
      >
        <v-icon left>
          mdi-calendar
        </v-icon>
        FECHA RECEPCIÓN: {{ apelacion.fecha_recepcion | formatDate }}
      </v-chip>
      <v-chip
        v-if="apelacion.status>=20"
        class="ma-2"
        color="grey darken-2"
        outlined
        label
      >
        <v-icon left>
          mdi-calendar
        </v-icon>
        FECHA CITACIÓN: {{ apelacion.fecha_citacion | formatDate }}
      </v-chip>
      <v-chip
        v-if="apelacion.status>=20"
        class="ma-2"
        color="grey darken-2"
        outlined
        label
      >
        <v-icon left>
          mdi-calendar
        </v-icon>
        FECHA TURNO: {{ apelacion.fecha_turno | formatDate }}
      </v-chip>
    </div>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" sm="6">
        <v-list>
          <v-list-item>
            <v-chip class="mr-3" small color="#607D8B" text-color="white" label>
              <b>EXPEDIENTE:</b>
            </v-chip>
            {{ apelacion.expediente }}
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-chip class="mr-3" small color="#607D8B" text-color="white" label>
              <b>NÚM OFICIO:</b>
            </v-chip>
            {{ apelacion.oficio }}
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-chip class="mr-3" small color="#607D8B" text-color="white" label style="min-width: 105px">
              <b>JUZGADO:</b>
            </v-chip>
            {{ apelacion.juzgado.nombre }} <br>
             DISTRITO {{ apelacion.juzgado.distrito_data.nombre }}
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-chip class="mr-3" small color="#607D8B" text-color="white" label>
              <b>TIPO DE OFICIO:</b>
            </v-chip>
            {{ apelacion.tipo_apelacion.nombre }}
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-chip class="mr-3" small color="#607D8B" text-color="white" label>
              <b>TIPO DE RECURSO:</b>
            </v-chip>
            {{ apelacion.tipo_apelacion.tipo_recurso }}
          </v-list-item>
          <v-divider></v-divider>
        </v-list>
      </v-col>
      <!-- <v-divider inset vertical></v-divider> -->
      <v-col cols="12" sm="6">
        <v-list>
          <v-list-item>
            <v-chip class="mr-3" small color="#607D8B" text-color="white" label>
              <b>APELANTE:</b>
            </v-chip>
            {{ apelacion.apelante }}
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-chip class="mr-3" small color="#607D8B" text-color="white" label>
              <b>INCULPADO:</b>
            </v-chip>
            {{ apelacion.inculpado }}
          </v-list-item>
          <v-divider></v-divider>
          <v-list class="ml-4 mr-4">
            <v-chip class="mr-3 mb-2" small color="#607D8B" text-color="white" label>
              <b>DELITO(S):</b>
            </v-chip>
            <ul v-for="(delito, i) in apelacion.apelacion_delitos" :key="i">
              <li><h4>{{ delito.delito.nombre }}</h4></li>
            </ul>
          </v-list>
          <v-divider></v-divider>
        </v-list>
      </v-col>
    </v-row>
  </span>
</template>

<script>
  export default {
    props: {
      apelacion: {
        type: Object,
        required: true
      }
    },
    data: () => ({
    }),
    mounted(){
    },
    methods:{
    }
  };
</script>

<style>
.v-chip.v-size--small {
  background: #e0e0e0;
  min-width: 107px;
}
</style>